var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27649 0.619038L0.636795 6.03314C0.434933 6.22653 0.274784 6.45624 0.165515 6.70912C0.0562446 6.962 -2.74669e-07 7.23309 -2.98603e-07 7.50686C-3.22537e-07 7.78063 0.0562445 8.05172 0.165515 8.3046C0.274784 8.55748 0.434933 8.78719 0.636795 8.98058L6.27649 14.3947C7.64831 15.6907 10 14.771 10 12.9105L10 2.10321C10 0.221865 7.64831 -0.697905 6.27649 0.619038Z",
    fill: "#1E415A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.8a7fadf356cac9cca0fa4a72ff5712c6.svg";
export { ForwardRef as ReactComponent };